import { useCallback } from "react";
import { fetchAllUsersDetailsPage } from "../apiCalls/usersApi";
import useInfiniteList from "./useInfiniteList";

export const PATIENT_OVERVIEW_PAGE_SIZE = 24;

const getPatientOverviewKey = (item) =>
  item?.userdetails_user_id || item?.user_id || item?.id || item?.userdetails_email;

const useInfinitePatientOverview = (search = "") => {
  const fetchPage = useCallback(
    (page, pageSize) => fetchAllUsersDetailsPage(pageSize, page, search),
    [search]
  );

  return useInfiniteList({
    fetchPage,
    getItemKey: getPatientOverviewKey,
    pageSize: PATIENT_OVERVIEW_PAGE_SIZE,
    resetKey: search,
  });
};

export default useInfinitePatientOverview;
